type PayLaterMessageProps = {
  price: number
}
export const PayLaterMessage = ({ price }: PayLaterMessageProps) => {
  return (
    <div data-pp-message data-pp-layout="flex" data-pp-amount={price}></div>
  )
}
